import type { ReactNode } from 'react';
import { type ExternalToast, toast as sonnerToast } from 'sonner';

export type ToastBodyOptions = Omit<ExternalToast, 'description'>;

function createToastBodyOptions(
  body: ReactNode,
  options?: ToastBodyOptions
): ExternalToast {
  return {
    ...options,
    description: body,
  };
}

function showSuccess(body: ReactNode, options?: ToastBodyOptions) {
  return sonnerToast.success('', createToastBodyOptions(body, options));
}

function showError(body: ReactNode, options?: ToastBodyOptions) {
  return sonnerToast.error('', createToastBodyOptions(body, options));
}

function showInfo(body: ReactNode, options?: ToastBodyOptions) {
  return sonnerToast.info('', createToastBodyOptions(body, options));
}

function showWarning(body: ReactNode, options?: ToastBodyOptions) {
  return sonnerToast.warning('', createToastBodyOptions(body, options));
}

function showMessage(body: ReactNode, options?: ToastBodyOptions) {
  return sonnerToast.message('', createToastBodyOptions(body, options));
}

export const toast = {
  success: showSuccess,
  error: showError,
  info: showInfo,
  warning: showWarning,
  message: showMessage,
  dismiss: (id?: string | number) => sonnerToast.dismiss(id),
};
